// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38jbI","tabsBox":"styles_tabsBox__1rd8T","createButton":"styles_createButton__2PvlL"};